import React, { useState, useRef } from "react";
import { Skeleton } from "./ui/skeleton";

export default function ImageWithSkeleton({ className = "", alt, decoding, fetchPriority, thumb, ...props }) {
  const [loaded, setLoaded] = useState(false);
  const [thumbLoaded, setThumbLoaded] = useState(false);
  const imgRef = useRef(null);

  return (
    <>
      {!thumbLoaded && !loaded && <Skeleton className="absolute inset-0 rounded-none" />}
      {thumb && !loaded && (
        <img
          src={thumb}
          alt=""
          className={`${className} transition-opacity duration-500 ${thumbLoaded ? "opacity-100" : "opacity-0"} blur-xl scale-110`}
          onLoad={() => setThumbLoaded(true)}
        />
      )}
      <img
        ref={imgRef}
        {...props}
        alt={alt}
        decoding={decoding}
        fetchPriority={fetchPriority}
        className={`${className} transition-opacity duration-500 ${loaded ? "opacity-100" : "opacity-0"}`}
        onLoad={() => setLoaded(true)}
      />
    </>
  );
}
